export default "__VITE_ASSET__BHumlrih__"